export const OssScene = {
  avatar: 'avatar',
  comment: 'comment',
  chat: 'chat',
} as const;

export type OssSceneValue = (typeof OssScene)[keyof typeof OssScene];
